<template>
  <div :class="['page-content']">
    <h2 :class="title">Cookie Policy</h2>
    <div v-html="page" />
    <vue-adsense ad-severity="block" :ad-client="adClient" ad-slot="8182071534" ad-format="fluid" ad-layout="in-article" />
  </div>
</template>
<script>
export default {
  name: 'CookiesPage',
  data () {
    return {
      page: null,
      title: this.$store.state.title || [],
      adClient: this.$store.state.googleAdSenseAdClient
    }
  },
  created () {
    this.$http('/static/pages/cookies.html').then(response => {
      this.page = response.data
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/cookies.vue